<template>
  <transition name="transition" :duration="{ enter: 750, leave: 250 }">
    <nav
      id="mobile-nav"
      v-if="isShowing"
      :style="{ '--height': primaryMenuHeight + 'px' }"
    >
      <div class="mobile-menu">
        <div
          class="mobile-menu__inner"
          v-bind:style="{ height: primaryMenuHeight + 'px' }"
        >
          <div
            ref="menuDepth0"
            class="mobile-menu__panel mobile-menu__panel--depth-0"
            v-if="menuData"
            :class="{ current: depth == 0, previous: depth > 0 }"
          >
            <ul class="mobile-menu-links">
              <li v-if="showHomeLink">
                <a href="/" :class="{ selected: currentId <= 0 }">Home</a>
              </li>

              <li v-for="post in menuData" :key="post.ID" :class="post.classes">
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  ><span v-html="post.title"></span>
                </a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>

          </div>

          <div
            ref="menuDepth1"
            class="mobile-menu__panel mobile-menu__panel--depth-1"
            v-if="menuForDepth1"
            :class="{
              current: depth == 1,
              previous: depth > 1,
              next: depth < 1,
            }"
          >
            <ul class="mobile-menu-links" v-if="selectedMenu0">
              <li :key="selectedMenu0.ID">
                <a
                  v-html="selectedMenu0.title"
                  :href="selectedMenu0.url"
                  v-on:click.prevent="didSelectPost(selectedMenu0, true)"
                ></a>
              </li>

              <li
                v-for="post in menuForDepth1"
                :key="post.ID"
                :class="post.classes"
              >
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  ><span v-html="post.title"></span
                ></a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>

            <div v-if="selectedMenu0" class="mobile-menu-footer">
              <a
                :href="selectedMenu0.url"
                v-on:click.prevent="didSelectBack()"
                class="back"
                ><img :src="arrow" alt="Back" />
                <span>Back</span>
              </a>
            </div>
          </div>

          <div
            ref="menuDepth2"
            class="mobile-menu__panel mobile-menu__panel--depth-2"
            v-if="menuForDepth2"
            :class="{
              current: depth == 2,
              previous: depth > 2,
              next: depth < 2,
            }"
          >
            <ul class="mobile-menu-links" v-if="selectedMenu1">
              <li :key="selectedMenu1.ID">
                <a
                  v-html="selectedMenu1.title"
                  :href="selectedMenu1.url"
                  v-on:click.prevent="didSelectPost(selectedMenu1, true)"
                ></a>
              </li>

              <li
                v-for="post in menuForDepth2"
                :key="post.ID"
                :class="post.classes"
              >
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  ><span v-html="post.title"></span
                ></a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>

            <div v-if="selectedMenu1" class="mobile-menu-footer">
              <a
                :href="selectedMenu1.url"
                v-on:click.prevent="didSelectBack()"
                class="back"
                ><svg
                  width="25"
                  height="16"
                  viewBox="0 0 25 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.40804 14.5735L2.82841 7.99384L9.40804 1.41421L7.99383 4.90415e-07L-1.26526e-05 7.99384L7.99383 15.9877L9.40804 14.5735ZM7.20166 8.99384L24.2017 8.99384L24.2017 6.99384L7.20166 6.99384L7.20166 8.99384Z"
                    fill="black"
                  />
                </svg>
                <span>Back</span>
              </a>
            </div>
          </div>

          <div
            ref="menuDepth3"
            class="mobile-menu__panel mobile-menu__panel--depth-3"
            v-if="menuForDepth3"
            :class="{ current: depth == 3, next: depth < 3 }"
          >
            <ul class="mobile-menu-links">
              <li
                v-for="post in menuForDepth3"
                :key="post.ID"
                :class="post.classes"
              >
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  ><span v-html="post.title"></span>
                </a>

                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>

            <div v-if="selectedMenu2" class="mobile-menu-footer">
              <a
                :href="selectedMenu2.url"
                v-on:click.prevent="didSelectBack()"
                class="back"
                ><svg
                  width="25"
                  height="16"
                  viewBox="0 0 25 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.40804 14.5735L2.82841 7.99384L9.40804 1.41421L7.99383 4.90415e-07L-1.26526e-05 7.99384L7.99383 15.9877L9.40804 14.5735ZM7.20166 8.99384L24.2017 8.99384L24.2017 6.99384L7.20166 6.99384L7.20166 8.99384Z"
                    fill="black"
                  />
                </svg>
                <span>Back</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </transition>
</template>

<script>
import Arrow from '../../images/arrow-basic.svg';

export default {
  data() {
    return {
      selectedPrimaryPost: null,
      selectedSecondaryPost: null,
      selectedTertiaryPost: null,
      selectedMenuData: null,
      arrow: Arrow,
      searchQuery: '',

      depth: 0,
      primaryMenuHeight: 300,

      selectedMenu0: null,
      selectedMenu1: null,
      selectedMenu2: null,
      selectedMenu3: null,
      // isShowingMenu: this.isShowingMenu ? this.isShowingMenu : false,
    };
  },

  props: {
    menuData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    mobileSubNav: {},
    currentId: {
      type: Number,
      default: -1,
    },
    isShowing: {
      type: Boolean,
      default: false,
    },
    showHomeLink: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    menuForDepth1: function () {
      return this.selectedMenu0 ? this.selectedMenu0.children : [];
    },
    menuForDepth2: function () {
      return this.selectedMenu1 ? this.selectedMenu1.children : [];
    },
    menuForDepth3: function () {
      return this.selectedMenu2 ? this.selectedMenu2.children : [];
    },
  },

  watch: {
    // depth: function (newValue, oldValue) { // eslint-disable-line no-unused-vars
    //   //this.layoutSubviews();
    // },
    // isShowing: function (newValue, oldValue) {
    //   // if(newValue) {
    //   //
    //   // }
    // },
  },

  methods: {
    layoutSubviews: function () {
      var height = 0,
        panelEl = this.$refs['menuDepth' + this.depth];

      if (typeof panelEl === 'undefined') return;

      height = panelEl.clientHeight;
      this.primaryMenuHeight = height;
    },
    didSelectBack: function () {
      if (this.depth > 0) {
        this.depth -= 1;
      }
    },
    didSelectPost: function (item, ignoreChildren = false) {
      const self = this;

      if (item.children && !ignoreChildren) {
        var newDepth = item.depth + 1;

        switch (newDepth) {
          case 1:
            {
              self.selectedMenu0 = item;
            }
            break;

          case 2:
            {
              self.selectedMenu1 = item;
            }
            break;

          case 3:
            {
              self.selectedMenu2 = item;
            }
            break;

          default:
        }

        self.depth = newDepth;

        return;
      }

      window.location.href = item.url;
      // self.isShowingMenu = false;
    },
  },

  components: {
    //PoseTransition,
  },

  mounted() {
    var self = this;
    setTimeout(function () {
      self.layoutSubviews();
    }, 150);
  },

  updated() {
    this.layoutSubviews();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

$mobile-menu-item-min-height: 72px;
$mobile-menu-footer-min-height: 82px;

#mobile-nav {
  position: absolute;
  top: 70px; //$header-height-xs;
  left: var(--gutter-mobile);
  right: var(--gutter-mobile);
  bottom: 0;
  z-index: 55;
  /* overflow: auto; */
  -webkit-overflow-scrolling: touch;
  background-color: transparent;
  /* padding-top: $header-height-xs; */

  .scrolled & {
    position: fixed;
    top: 70px;
    background-color: transparent;
    height: var(--height);

    /* .mobile-menu {
      background-color: var(--green);

      &__inner {
        background-color: var(--green);
      }
    } */
  }

  /* .admin-bar & {
		//top: $header-height-xs + $admin-bar-height-xs;
		padding-top: $header-height-xs + $admin-bar-height-xs;

		@media (max-width: $tablet) {
			//top: $header-height-xs + $admin-bar-height;
			padding-top: $header-height-xs + $admin-bar-height;
		}
	} */

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.25s;

    .container {
      transition: transform 0.25s;
    }
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }

  &.fade-leave-to {
    .container {
      transform: translateY(-10px);
    }
  }

  &.transition-enter-active,
  &.transition-leave-active {
    transition: background 0.15s ease-in-out, opacity 0.1s ease-in-out;

    .mobile-menu {
      transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    }
  }

  &.transition-enter-active {
    .mobile-menu {
      transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

      .page-showing-menu & {
        transition-delay: 0.25s;
      }
    }
  }

  &.transition-leave-active {
    .mobile-menu {
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
    }
  }

  &.transition-enter,
  &.transition-leave-to {
    /* background-color: var(--purple); */

    .mobile-menu {
      //opacity: 0;
      transform: translateY(-120%);
    }
  }

  .mobile-menu {
    /* position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0; */
    /* overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between; */
    background: white;
    transition: 0.2s ease all;
    border-radius: 15px 15px 15px 15px;
    overflow: hidden;

    &__inner {
      position: relative;
      overflow: hidden;
      background: white;
      color: var(--purple);
      transition: 0.2s ease all;

      .back {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /* min-height: $mobile-menu-footer-min-height; */
        position: relative;
        text-decoration: none;
        color: var(--dark-purple);
        opacity: 1;
        gap: 9.5px;
        font-weight: bold;
        letter-spacing: 0.14px;
        padding: 16px 0 16px;

        &:hover,
        &:active {
          text-decoration: none;
          opacity: 1;
        }
      }
    }

    &__panel {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: $z-index-low;
      transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;

      &.next {
        pointer-events: none;
        transform: translateX(50%);
        opacity: 0;
      }

      &.current {
        pointer-events: all;
        transform: translateX(0);
        opacity: 1;
        z-index: $z-index-medium;
      }

      &.previous {
        pointer-events: none;
        transform: translateX(-50%);
        opacity: 0;
      }

      .mobile-menu-footer {
        // border-top: solid 1px white;
        padding: 0 $page-gutter-width-xs;

				img {
					transform: rotate(180deg);
				}
      }

      .mobile-menu-links {
        list-style: none;
        margin: 0;
        padding: 0 $page-gutter-width-xs;

        > li {
          margin: 0;
          padding: 0;
          display: block;
          border-bottom: solid 1px var(--light-purple);
          display: flex;
          justify-content: space-between;

					&:last-of-type {
						border-bottom: none;
					}

          &:first-child {
            border-top: none;
          }

          > img {
            padding: 16px 0 16px 32px;

            &:hover {
              cursor: pointer;
            }
          }

          > a {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            /* min-height: $mobile-menu-item-min-height; */
            color: var(--dark-purple);
            opacity: 1;
            text-decoration: none;
            padding: 16px 0 16px;
            width: 100%;

            &:hover,
            &:active {
              text-decoration: none;
              opacity: 1;

              &::before {
                opacity: 1;
                //background-color: map-get($theme-colours, ocean-blue);
              }

              &::after {
                transform: translateX(5px);
              }
            }

            &.selected {
              //color: map-get($theme-colours, ocean-blue);
              opacity: 0.7;

              &.has-children {
                &:hover,
                &:active {
                  text-decoration: none;
                }
              }
            }
          }
        }

        &.sub_nav {
          padding-top: 0;

          li {
            border-bottom: 0;

            &:first-of-type {
              padding-top: 0;
            }

            a {
              font: normal normal normal 14px/20px var(--primary-font-family);
              letter-spacing: 0px;

              padding: 12px 0 12px;
            }
          }
        }
      }

      &--depth-1,
      &--depth-2,
      &--depth-3,
      &--depth-4 {
        .mobile-menu-links {
          padding: 0 $page-gutter-width-xs 0 $page-gutter-width-xs;

          > li {
            /* border-bottom: none; */

            a {
              padding: 24px 0 16px;
            }

            &:first-child {
              border-bottom: solid 1px var(--light-purple);
              padding-top: 0;

              a {
                border: none;
                opacity: 1;
                font-weight: bold;
                letter-spacing: 0px;
                color: var(--dark-purple);
              }
            }

            &:last-child {
              > a {
                border-bottom: solid 1px var(--light-purple);
                padding: 16px 0 16px 0;
              }
            }

            > a {
              opacity: 1;
              color: var(--dark-purple);
              text-transform: none;
              min-height: auto;
              padding: 1rem 0;
            }

            &:not(:first-child) {
              border-top: 0;
            }
          }
        }
      }
    }

    &__footer {
      text-align: center;
      padding: 0 $page-gutter-width-xs;
      // padding-top: ($grid-gutter-width/2);
      // padding-bottom: 0;

      .search-box {
        margin-bottom: ($grid-gutter-width/2);
      }

      .social {
        justify-content: flex-start;
        margin-bottom: ($grid-gutter-width/2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MobileMenu.vue